import React, { FC } from 'react';
import Page from 'evcharging/components/Page';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import { HOME_LINK } from 'evcharging/app/seo/pages';
import { I18nPage } from 'i18n/types/pages.enum';
import Header from 'evcharging/containers/lp/Header'
import Start from 'evcharging/containers/lp/start';
import WhatsInItForYou from 'evcharging/containers/lp/WhatsInItForYou';
import Why from 'evcharging/containers/lp/Why';
import Hospitality from 'evcharging/containers/lp/Hospitality'
import Faq from 'evcharging/containers/lp/Faq'
import Footer from 'evcharging/containers/lp/Footer'

const IndexPage: FC<StaticPageProps> = ({ page }) => (
  <Page
    locales={page.locales}
    title={page.meta_title || 'Start charging today with Energy5 turnkey solutions' }
    description={page.meta_description || 'Turn your location into a charging destination with our all-in-one universal solution designed for all electric and hybrid vehicle manufacturers'}
  >
    <Header />
    <Start />
    <WhatsInItForYou />
    <Why />
    <Hospitality />
    <Faq />
    <Footer />
  </Page>
);

export const getServerSideProps = createGetServerSideProps(
  HOME_LINK,
  undefined,
  [I18nPage.EvChargingCommon, I18nPage.EvChargingHome, I18nPage.EnergyRates, I18nPage.Blog]
);

export default IndexPage;